import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformV2ClientResponse, transformKeysToSnakeCase, transformKeysToCamelCase } from 'helpers/core';
import URLS from 'constants/urls';

const methods = {
  create: (httpClient, { venueId, ...rest }) =>
    httpClient
      .post(URLS.campaigns.create(venueId), transformKeysToSnakeCase(rest), { ignoreInternalError: true })
      .then(() => methods.read(httpClient, { venueId })),
  read: (httpClient, { venueId }) =>
    httpClient
      .get(URLS.campaigns.read(venueId))
      .then(transformV2ClientResponse)
      .then(data => data?.campaigns ?? []),
  options: (httpClient, { venueId }) =>
    httpClient
      .get(URLS.campaigns.options(venueId))
      .then(transformV2ClientResponse)
      .then(data => data?.campaignTypeOptions ?? []),
  update: (httpClient, { venueId, partnerCampaignId, ...rest }) =>
    httpClient
      .patch(URLS.campaigns.update(partnerCampaignId), transformKeysToSnakeCase(rest))
      .then(() => methods.read(httpClient, { venueId })),
  getOne: (httpClient, { partnerCampaignId }) =>
    httpClient.get(URLS.campaigns.getOne(partnerCampaignId)).then(response => transformKeysToCamelCase(response)),
};

export const handler = ({ httpClient }, method = 'read', payload) => methods[method](httpClient, payload);

export default makeEntityScaffold('SAGA.API.CAMPAIGNS', handler, {
  defaultKey: (_, method = 'read', { venueId = '', partnerCampaignId = '' }) => {
    let secondKey;
    switch (method) {
      case 'options':
        secondKey = 'options';
        break;
      case 'getOne':
        secondKey = partnerCampaignId;
        break;
      default:
        secondKey = 'read';
    }
    return `${venueId}-${secondKey}`;
  },
  method: Object.keys(methods).reduce((acc, method) => ({ ...acc, [method]: method }), {}),
});
